import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import TaskListLayouts from '../../layouts/TaskListLayout/TaskListLayout';
import getJobList, {
  completeJobManually,
  printJobList,
  printJobListFinished,
} from '../../redux/actions/getJobList';
import {
  endMessageForTaskTable,
  endMessageTaskPagination,
} from '../../utils/Constants';
import formReportDetails from '../../redux/actions/addReportCat';
import endpoints from '../../routes';
import { reportCat } from '../../redux/actions/reportCategory';
import { clearInspectionState } from '../../redux/actions/updateAnswer';
import { setPageHeader, clearPageHeader } from '../../redux/actions/pageHeader';
import { displayToast } from '../../_helpers/commonFunctions';
import TaskModalBody from '../../layouts/CustomerHomeNewLayout/taskModalBody';
import Modal from '../../components/Modal/Modal';
import Loader from '../../components/Loader';

export class TaskListView extends React.Component {
  constructor(props) {
    super(props);
    this.page = 1;
    this.LIMIT = 50;
  }

  state = {
    searchText: '',
    filter: undefined,
    reportType: '',
    reportCategory: [],
    startDate: '',
    endDate: '',
    jobDateSort: -1,
    isClassVisible: {},
    businessNameSort: undefined,
    isCrossVisible: false,
    endMessage: endMessageTaskPagination,
    selectedTask: [],
    isTaskModal: false,
    jobsDoneManually: [],
    viewMode: null,
  };

  reloadList = () => {
    this.props.getJobList(
      this.page,
      this.LIMIT,
      this.state.searchText,
      this.state.status,
      this.state.reportCategory,
      this.state.jobDateSort,
      this.state.businessNameSort,
      this.state.startDate,
      this.state.endDate,
      this.state.reportType
    );
  };

  setReportType = (reportType) => {
    this.page = 1;
    this.setState(
      {
        reportType,
      },
      () => this.reloadList()
    );
  };

  applyFilter = (filter) => {
    this.page = 1;
    const status = this.appliedFilters(filter.statusFilters);
    const reportCategory = this.appliedFilters(filter.reportFilters);
    this.setState(
      {
        status,
        reportCategory,
      },
      () => this.reloadList()
    );
  };

  setViewMode = (mode) => {
    this.page = 1;
    const timeZone = this.props.auth?.login?.user?.timeZone ?? 'UTC';
    const now = moment.tz(timeZone);
    let startDate;
    let endDate;

    switch (mode) {
      case 'day':
        startDate = now.clone().startOf('day').valueOf();
        endDate = now.clone().endOf('day').valueOf();
        break;
      case 'week':
        startDate = now.clone().startOf('week').valueOf();
        endDate = now.clone().endOf('week').valueOf();
        break;
      case 'month':
        startDate = now.clone().startOf('month').valueOf();
        endDate = now.clone().endOf('month').valueOf();
        break;
      default:
        return;
    }

    this.setState({ viewMode: mode, startDate, endDate }, () =>
      this.reloadList()
    );
  };

  setDatePeriod = (startDate, endDate) => {
    this.page = 1;
    const startMonth = moment(startDate).get('month');
    const startYear = moment(startDate).get('year');
    const todayMonth = moment().get('month');
    const todayYear = moment().get('year');
    const isThisMonth = startMonth === todayMonth && startYear === todayYear;
    const start = isThisMonth ? moment().startOf('day') : moment(startDate);
    this.setState(
      {
        startDate: start.valueOf(),
        endDate: moment(endDate).valueOf(),
        viewMode: null,
      },
      () => this.reloadList()
    );
  };

  appliedFilters = (array) => {
    const newArray = Object.keys(array).filter((item) => array[item]);
    return newArray;
  };

  setFilters = (filters) => {
    this.setState(
      {
        filter: filters,
      },
      () => this.applyFilter(this.state.filter)
    );
  };

  printPage = () => {
    this.props.printJobList(
      1,
      false,
      this.state.searchText,
      this.state.status,
      this.state.reportCategory,
      this.state.jobDateSort,
      this.state.businessNameSort,
      this.state.startDate,
      this.state.endDate,
      this.state.reportType
    );
  };

  componentDidUpdate(prevProps) {
    const { jobsCompletedManually } = this.props;
    if (
      jobsCompletedManually.success &&
      jobsCompletedManually.success !== prevProps.jobsCompletedManually.success
    ) {
      displayToast(jobsCompletedManually.success, 'success');
      let _jobsDoneManually = [...this.state.jobsDoneManually];
      _jobsDoneManually.push(jobsCompletedManually.jobDetail.jobId);
      _jobsDoneManually = Array.from(new Set(_jobsDoneManually));
      this.setState({ jobsDoneManually: [..._jobsDoneManually] });
    } else if (
      jobsCompletedManually.error &&
      jobsCompletedManually.error !== prevProps.jobsCompletedManually.error
    ) {
      displayToast(jobsCompletedManually.error, 'error');
    }

    this.handleResponseForJobListDownload(prevProps);
  }

  componentDidMount() {
    this.page = 1;
    this.props.setPageHeader({
      title: 'Jobs Due This Month',
      ariesLayout: true,
      crumbs: [
        { label: 'Home', path: '/' },
        { label: 'Jobs', path: endpoints.task },
        { label: 'Jobs Due This Month', path: endpoints.dueThisMonth },
      ],
    });
    this.setState(
      {
        startDate: moment().startOf('day').valueOf(),
        endDate: moment().endOf('month').valueOf(),
      },
      () =>
        this.props.getJobList(
          this.page,
          this.LIMIT,
          null,
          null,
          null,
          this.state.jobDateSort,
          null,
          this.state.startDate,
          this.state.endDate,
          null
        )
    );
    this.props.reportCat();
  }

  componentWillUnmount() {
    this.props.clearPageHeader();
  }

  setSearchText = (text) => {
    this.setState({ searchText: text, isCrossVisible: true });
  };

  handleResponseForJobListDownload = (prevResponse) => {
    const { success, error, printData } = this.props;

    if (success && printData) {
      displayToast(success, 'success');
      globalThis.window.open(printData);
      this.props.printJobListFinished();
    } else if (error && prevResponse.error !== error) {
      displayToast(error, 'error');
    }
  };

  handleOnSearch = (text) => {
    this.page = 1;
    if (text === '') {
      this.setState({ searchText: '', isCrossVisible: false }, () =>
        this.reloadList()
      );
    }
    this.reloadList();
  };

  loadMore = () => {
    this.page += 1;
    this.reloadList();
  };

  // Handle Mobile Table View
  setClassVisibility = (jobId) => {
    const isClassVisible = {};
    if (Object.keys(this.state.isClassVisible[0] === jobId)) {
      isClassVisible[`${jobId}`] = !this.state.isClassVisible[`${jobId}`];
    } else {
      isClassVisible[`${jobId}`] = true;
    }
    this.setState({ isClassVisible });
  };

  handleStartJob = (reportData) => {
    let formData = {};
    formData = {
      typeValue: reportData.type,
      catValue: reportData.reportCategory,
      customerValue: reportData.createdFor._id,
      frequency: reportData.frequency,
      price: reportData.price,
    };
    this.props.clearInspectionState();
    this.props.formReportDetails(formData);
    displayToast('Report started successfully', 'success');
    this.props.history.push(endpoints.reportClientDetail, {
      jobId: reportData.jobId,
      reportCategory: reportData.reportCategory,
    });
  };

  isEndMessageVisible = () =>
    this.page > 1 || (this.props.jobList && this.props.jobList.length) === 0;

  sortData = (index) => {
    this.page = 1;
    const { businessNameSort, jobDateSort } = this.state;
    if (index === 1) {
      this.setState(
        {
          businessNameSort:
            businessNameSort === undefined ? 1 : businessNameSort * -1,
        },
        () => this.reloadList()
      );
    } else {
      this.setState(
        {
          jobDateSort: jobDateSort === undefined ? 1 : jobDateSort * -1,
        },
        () => {
          this.reloadList();
        }
      );
    }
  };

  showTaskModdal = (tasks) => {
    this.setState({
      isTaskModal: true,
      selectedTask: tasks,
    });
  };

  render() {
    return (
      <>
        {this.props.jobsCompletedManually.isFetching && <Loader />}
        {this.state.isTaskModal ? (
          <Modal
            modalId="job-link"
            modalHeading="Tasks"
            ModalBody={TaskModalBody}
            ModalBodyProps={{
              task: this.state.selectedTask,
              inspectionDetails: { isFetching: false },
            }}
            handleClickCross={() => this.setState({ isTaskModal: false })}
          />
        ) : null}
        <TaskListLayouts
          isCrossVisible={this.state.isCrossVisible}
          searchText={this.state.searchText}
          jobList={this.props.jobList}
          setFilters={this.setFilters}
          printPage={this.printPage}
          setSearchText={this.setSearchText}
          reportCategory={this.state.reportCategory}
          handleSearch={this.handleOnSearch}
          loadMore={this.loadMore}
          isfetching={this.props.isfetching}
          hasMoreItems={this.page < this.props.pages}
          isClassVisible={this.state.isClassVisible}
          setClassVisibility={this.setClassVisibility}
          sortData={this.sortData}
          filter={this.state.filter}
          endMessage={
            this.props.jobList && this.props.jobList.length > 0
              ? this.state.endMessage
              : endMessageForTaskTable
          }
          setDatePeriod={this.setDatePeriod}
          setReportType={this.setReportType}
          handleStartJob={this.handleStartJob}
          reportType={this.state.reportType}
          isEndMessageVisible={this.isEndMessageVisible()}
          reportCategories={this.props.reportCategories}
          showTaskModdal={this.showTaskModdal}
          completeJobManually={this.props.completeJobManually}
          jobsDoneManually={this.state.jobsDoneManually}
          isReportNeeded={this.props.isReportNeeded}
          viewMode={this.state.viewMode}
          setViewMode={this.setViewMode}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  jobList: state.getJobsList.jobData,
  printData: state.getJobsList.printData,
  success: state.getJobsList.success,
  error: state.getJobsList.error,
  pages: state.getJobsList.pages,
  isfetching: state.getJobsList.isfetching,
  reportCategories: state.reportCategory.reportData,
  jobsCompletedManually: state.getJobsList.jobsCompletedManually || {},
  isReportNeeded: state.auth.login.user.isReportNeeded,
  auth: state.auth,
});

TaskListView.propTypes = {
  jobList: PropTypes.array,
  isfetching: PropTypes.bool,
  pages: PropTypes.number,
  getJobList: PropTypes.any,
  printJobList: PropTypes.any,
  reportCategories: PropTypes.object,
  reportCat: PropTypes.func,
  formReportDetails: PropTypes.func,
  clearInspectionState: PropTypes.func,
  history: PropTypes.object,
  completeJobManually: PropTypes.func,
  jobsCompletedManually: PropTypes.object,
  isReportNeeded: PropTypes.any,
  setPageHeader: PropTypes.func,
  clearPageHeader: PropTypes.func,
  auth: PropTypes.object,
  success: PropTypes.string,
  error: PropTypes.string,
  printData: PropTypes.string,
  printJobListFinished: PropTypes.func,
};

export default connect(mapStateToProps, {
  getJobList,
  reportCat,
  clearInspectionState,
  formReportDetails,
  printJobList,
  completeJobManually,
  printJobListFinished,
  setPageHeader,
  clearPageHeader,
})(TaskListView);
